// extracted by mini-css-extract-plugin
module.exports = {"section":"Welcome_section__24qKf","message":"Welcome_message__hBjVX"};